import React, { useEffect, useState } from 'react';
import { getSafevaultSiteUrls } from '../../utils/safevaultSiteUrls';
import { headerHtml } from '../../utils/shellMarkup';

export default function LandingAppBar() {
 const [open,setOpen]=useState(false);
 const [dropdown,setDropdown]=useState('');
 const [scrolled,setScrolled]=useState(false);
 const urls=getSafevaultSiteUrls();
 useEffect(()=>{
  const scroll=()=>setScrolled(window.scrollY>24);
  const resize=()=>{if(window.innerWidth>=1280)setOpen(false);};
  const key=e=>{if(e.key==='Escape'){setOpen(false);setDropdown('');}};
  scroll(); window.addEventListener('scroll',scroll);window.addEventListener('resize',resize);document.addEventListener('keydown',key);
  return ()=>{window.removeEventListener('scroll',scroll);window.removeEventListener('resize',resize);document.removeEventListener('keydown',key);};
 },[]);
 useEffect(()=>{
  if(!open)return;
  const previous=document.body.style.overflow;document.body.style.overflow='hidden';
  return ()=>{document.body.style.overflow=previous;};
 },[open]);
 const click=e=>{
  if(e.target.closest('[data-toggle-menu]'))setOpen(!open);
  const button=e.target.closest('[data-dropdown]');
  if(button)setDropdown(dropdown===button.dataset.dropdown?'':button.dataset.dropdown);
  if(e.target.closest('a')){setOpen(false);setDropdown('');}
 };
 return <header className="sv-shell-header" data-scrolled={scrolled||open} onClick={click} dangerouslySetInnerHTML={{__html:headerHtml(item=>item.href || urls[item.hrefKey],open,dropdown)}} />;
}
